// src/components/Capabilities/Capabilities.jsx
import React, { useEffect } from 'react';
import Navbar from '../Navbar/navbar'; // Correct path to Navbar
import Footer from '../Footer/Footer'; // Correct path to Footer
import './Capabilities.css';

// Import Icons
import iconStamping from '../../assets/Capabilities/Press machine.png';
import iconTooling from '../../assets/Capabilities/Engineering.png';
import iconDie from '../../assets/Capabilities/Moulding box.png';
import iconWelding from '../../assets/Capabilities/Mechanical arm.png';
import iconMolding from '../../assets/Capabilities/Molding machine.png';
import iconCNC from '../../assets/Capabilities/Cnc machine.png';
import iconQuality from '../../assets/Capabilities/Technical drawing.png';
import iconOEM from '../../assets/Capabilities/Work list.png';
import iconISO from '../../assets/Capabilities/Quality control.png';

const Capabilities = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const capabilities = [
    {
      title: "Precision Automotive Metal Stamping",
      desc: "High-precision stamping solutions for structural, safety, and functional automotive components with consistent quality and repeatability.",
      icon: iconStamping
    },
    {
      title: "Tool Design & Development (In-House Tool Room)",
      desc: "Integrated tool design, die manufacturing, and maintenance ensuring faster development cycles and process control.",
      icon: iconTooling
    },
    {
      title: "Progressive & Transfer Die Manufacturing",
      desc: "Advanced die solutions engineered for high-volume automotive production with tight tolerances and durability.",
      icon: iconDie
    },
    {
      title: "Robotic Welding",
      desc: "Automated welding systems delivering strength, consistency, and improved cycle efficiency across assemblies.",
      icon: iconWelding
    },
    {
      title: "Injection Moulding",
      desc: "Precision plastic moulding solutions integrated with stamped assemblies for complete component manufacturing.",
      icon: iconMolding
    },
    {
      title: "CNC Machining (VMC, Wire Cut, etc.)",
      desc: "High-accuracy machining operations supporting tooling, fixtures, and precision automotive components.",
      icon: iconCNC
    },
    {
      title: "Vision Inspection & Quality Testing",
      desc: "Automated inspection and testing systems ensuring dimensional accuracy and zero-defect performance.",
      icon: iconQuality
    },
    {
      title: "OEM Project Support & New Product Development",
      desc: "End-to-end engineering support from tooling design to production ramp-up for OEM programs.",
      icon: iconOEM
    },
    {
      title: "IATF / ISO Quality Systems",
      desc: "Certified quality management systems aligned with global automotive standards and compliance requirements.",
      icon: iconISO
    }
  ];

  return (
    <div className="capabilities-page-wrapper">
      <Navbar />



      <div className="container py-5 mt-3">
        {/* Header */}
        <div className="text-start mb-5 pt-5">
          <h1 className=" fw-bold text-dark mb-3">Capabilities</h1>
          <p className="lead text-dark fw-medium" style={{ fontSize: "16px" }}>
            Integrated Manufacturing & Engineering Solutions for Automotive OEMs
          </p>
        </div>

        {/* Grid */}
        <div className="row g-4">
          {capabilities.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="cap-new-card">
                <div className="cap-icon-box">
                  <img src={item.icon} alt={item.title} className="cap-new-icon" />
                </div>
                <div className="cap-content">
                  <h5 className="cap-new-title">{item.title}</h5>
                  <p className="cap-new-desc">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Capabilities;